
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {translate} from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import DateOfBirthInput from '../../common/DateOfBirthInput'


const styles = theme => ({
  dateOfBirth: {
    marginBottom: theme.spacing.unit * 5,
    width: '100%'
  },
  fullWidth: {width: '100%'}
})

class Detail extends Component {
  state = {
    dateOfBirth: this.props.dateOfBirth,
    firstName: this.props.firstName,
    lastName: this.props.lastName,
    medicalRecordNumber: this.props.medicalRecordNumber,
    validDobForApi: this.props.isDobInputValueValidForApi(this.props.dateOfBirth),
  }

  componentDidUpdate(prevProps) {
    for(let field in this.state) {
      const currentPropValue = this.props[field]
      if((prevProps[field] !== currentPropValue) && (this.state[field] !== currentPropValue)) {
        this.setState({[field]: currentPropValue})
      }
    }
  }

  handleChange(event) {
    const name = event.target.name
    const value = event.target.value

    if (name === 'dateOfBirth') {
      this.setState({validDobForApi: this.props.isDobInputValueValidForApi(value)})
      this.props.amendNavigationPerDateOfBirth(value)
    }

    this.setState({[name]: value})
  }

  addPatientDetails(event) {
    if (event.target.name === 'dateOfBirth' && !this.props.isDobInputValueValidForApi(event.target.value)) {
      return
    }

    this.props.addPatientDetails(event.target.name, event.target.value)
  }

  copyCaseIdToMRN = () => {
    this.props.addPatientDetails('medicalRecordNumber', this.props.caseId)
    this.setState({medicalRecordNumber: this.props.caseId})
  }

  render() {
    const {classes, t, isCounselingSessionDisabled} = this.props
    return (
      <Grid
        container
        justify="center"
        spacing={24}
      >
        <Grid item xs={12}>
          <TextField
            className={classes.fullWidth}
            id="first-name"
            InputLabelProps={{shrink: !!this.state.firstName}}
            label={t('First Name')}
            multiline
            name="firstName"
            onBlur={this.addPatientDetails.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.state.firstName}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={classes.fullWidth}
            id="last-name"
            InputLabelProps={{shrink: !!this.state.lastName}}
            label={t('Last Name')}
            multiline
            name="lastName"
            onBlur={this.addPatientDetails.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.state.lastName}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={classes.fullWidth}
            id="medical-record-number"
            // this shrinks label when value is set dynamically
            InputLabelProps={{shrink: !!this.state.medicalRecordNumber}}
            label={t('Medical Record Number')}
            multiline
            name="medicalRecordNumber"
            onBlur={this.addPatientDetails.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.state.medicalRecordNumber}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>
        {!isCounselingSessionDisabled && (
          <Grid item xs={12}>
            <Button
              className={classes.button}
              color="primary"
              onClick={this.copyCaseIdToMRN}
              variant="contained"
            >
              <Typography style={{fontSize: 10, color: 'white'}}>
                {t('Copy Case ID')}
              </Typography>
              &nbsp;&nbsp;
              <ArrowUpward style={{fontSize: 20}}/>
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <DateOfBirthInput
            className={classes.fullWidth}
            error={!this.state.validDobForApi}
            id="date-of-birth"
            label={t('Date of Birth')}
            name="dateOfBirth"
            onBlur={this.addPatientDetails.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.state.dateOfBirth}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>
      </Grid>
    )
  }
}

Detail.propTypes = {
  addPatientDetails: PropTypes.func.isRequired,
  amendNavigationPerDateOfBirth: PropTypes.func.isRequired,
  caseId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  dateOfBirth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]).isRequired,
  firstName: PropTypes.string.isRequired,
  isDobInputValueValidForApi: PropTypes.func.isRequired,
  lastName: PropTypes.string.isRequired,
  medicalRecordNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  isCounselingSessionDisabled: PropTypes.bool
}

export default compose(
  translate(),
  withStyles(styles)
)(Detail)


// WEBPACK FOOTER //
// ./src/components/counseling-session/report/Detail.js